import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { formatTimeAgo, secondsToFormattedTime } from '../../utils/dateTimeFormatUtils';
import { sanitizeHtml } from '../../utils/sanitizeHtml';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const CommentViewerPopoverContent = ({
  comment,
  speakerName,
  timestampSeconds,
  totalCommentsAtTimestamp
}) => {
  const replyCount = totalCommentsAtTimestamp - 1;
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "200",
    padding: "200",
    "data-test-id": "commentViewerPopoverContent",
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsxs(Text, {
        typography: "heading-300",
        color: "text-interactive-default",
        children: [secondsToFormattedTime(timestampSeconds), " - ", speakerName]
      })
    }), /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-200",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "recordingReviewComponents.transcript.utterance.commentTimeAgo",
          options: {
            time: formatTimeAgo(comment.createdAt)
          }
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      maxInlineSize: "300px",
      children: /*#__PURE__*/_jsx("div", {
        dangerouslySetInnerHTML: {
          __html: sanitizeHtml(comment.message)
        }
      })
    }), replyCount > 0 && /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-125",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "recordingReviewComponents.transcript.utterance.replyCount",
          options: {
            count: replyCount
          }
        })
      })
    })]
  });
};